<template slot-scope="props">
  <div id="SendSurveyContainer" class="blue-backgroud">
    <b-container id="SendSurvey">
      <b-row id="Top" class="p-3">
        <b-col align-self="center" cols="2">
          <h1>Send a Survey</h1>
        </b-col>
        <b-col align-self="center" cols="4">
          <b-progress
            id="progress-bar"
            :value="value"
            :max="max"
            class="mb-3"
          ></b-progress>
        </b-col>
      </b-row>
      <form-wizard ref="wizard" id="" title="" subtitle="">
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Choose <br/>type of survey</h3>
              <div class="img__container">
                <img
                  src="../../../public/img/icons/wizard-icon-add.png"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content" cols="8">
              <b-row class="buttons__container">
                <b-col class="mb-5 d-flex justify-content-end">
                  <a
                    :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                    @click="goNext()"
                  >
                  {{ nextButtontext }} <font-awesome-icon icon="angle-right" />
                  </a>
                </b-col>
              </b-row>
              <div id="survey-types" v-if="notEmptyObject(groups)">
                <div v-for="(group, id, index) in groups" :key="index">
                  <div class="group-container" v-if="group.show">
                    <label v-bind:id="'group-'" :class="['container', 'group-name', { active: checkGroup == id}]"
                      >{{ group.name }}
                      <input
                        v-model="checkGroup"
                        v-bind:value="id"
                        type="radio"
                        name="SurveyGroups"
                      />
                      <span class="checkmark"></span>
                    </label>
                    <span class="survey-group-description">{{ group.description }}</span>
                    <SurveyFormatTabs
                      v-show="checkGroup == id"
                      :current_tab="checkSurveyFormat"
                      @surveyFormat="setCheckSurveyFormat"
                      :current_group="group"
                    />
                    <div class="surveys-container" v-show="checkGroup == id">
                      <template v-for="(survey, sid, sidx) in group.surveys" v-cloak>
                        <div
                          class="survey-container"
                          v-if="survey.survey.format == checkSurveyFormat" :key="sid"
                        >
                          <div class="survey" v-if="group.multiple">
                            <label
                              v-bind:id="'survey-'"
                              :key="sidx"
                              class="container survey-name"
                              >{{ survey.title }}
                              <template
                                v-if="survey.survey && survey.survey.questions"
                                >({{
                                  survey.survey.questions.length
                                }}
                                questions)</template
                              >
                              <input
                                v-model="checkSurvey"
                                v-bind:value="sid"
                                type="radio"
                                name="Survey"
                              />
                              <span class="checkmark"></span>
                            </label>
                            <div
                              class="see-questions"
                              v-on:click="toggleQuestions(sidx)"
                            >
                              See questions
                            </div>
                          </div>
                          <div
                            class="questions-list"
                            :id="`questions-${sid}`"
                            v-if="
                              visibleSurveyQuestions == sidx || !group.multiple
                            "
                          >
                            <div
                              class="sub-question"
                              v-for="(question, mindex) in survey.survey
                                .questions"
                              :key="mindex"
                            >
                              <span class="topic"
                                >{{ mindex + 1 }}.
                                {{
                                  question.question_type == "free_form"
                                    ? "Comments"
                                    : question.topic
                                }}
                                -
                              </span>
                              {{ question.question_text }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Describe <template v-if="keyType">{{ keyType.toLowerCase() }}</template></h3>
              <div class="img__container">
                <img
                  src="../../../public/img/icons/wizard-icon-describe.png"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content" cols="8">
              <b-row class="buttons__container">
                <b-col class="mb-5 d-flex justify-content-end">
                  <a
                    v-on:click="goBack()"
                    v-if="this.active_tab > 0"
                    :class="['back-button', { disabled: !previousButtonAvailable }]"
                    >
                    <font-awesome-icon icon="angle-left" />
                    BACK
                  </a>
                  <a
                    :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                    @click="goNext()"
                  >
                  {{ nextButtontext }} <font-awesome-icon icon="angle-right" />
                  </a>
                </b-col>
              </b-row>
              <div class="mb-4" id="presentation-info">
                <h3 class="mb-4">{{ keyType }} information</h3>
                <div class="inputField">
                  <b-form>
                    <b-row>
                      <b-form-group>
                        <div class="input-wrapper">
                          <b-form-input
                            class="mr-3"
                            :required="true"
                            id="presentation_name"
                            name="presentation_name"
                            v-model="$v.form.presentation_name.$model"
                            :state="validateState('presentation_name')"
                          />
                          <label for="presentation_name">{{ keyType }} name</label
                          >
                          <b-form-invalid-feedback id="input-1-live-feedback">
                            This is a required field
                          </b-form-invalid-feedback>
                        </div>
                      </b-form-group>

                      <b-form-group>
                        <div id="date-picker-container">
                          <span id="date-input-label">{{ keyType }} date</span>
                          <b-form-datepicker
                            :disabled="overall"
                            id="presentation_date"
                            name="presentation_date"
                            v-model="form.presentation_date"
                            :max="minDate"
                            locale="en"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'numeric',
                              day: '2-digit',
                            }"
                            :hide-header="true"
                          ></b-form-datepicker>
                        </div>
                      </b-form-group>
                    </b-row>
                  </b-form>
                </div>
              </div>
              <b-row class="mb-4">
                <div id="invitation_message">
                  <label for="welcome_message">Invitation message (You can personalize your message)</label>
                  <b-form-textarea
                    id="welcome_message"
                    rows="7"
                    v-model="$v.currentWelcomeMessage.$model"
                    :state="validateExtraFields('currentWelcomeMessage')"
                  ></b-form-textarea>
                </div>
              </b-row>
              <b-row class="mb-4">
                <div id="thank_you_message">
                  <label for="thanks_message">Thank You message</label>
                  <b-form-textarea
                    id="thanks_message"
                    rows="7"
                    v-model="$v.defaultThanksMessage.$model"
                    :state="validateExtraFields('defaultThanksMessage')"
                  ></b-form-textarea>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content>
          <b-row class="content">
            <b-col class="left-content" cols="4">
              <h3>Share <br/>survey two ways</h3>
              <div class="img__container">
                <img
                  src="../../../public/img/icons/wizard-icon-share.png"
                  class="img-fluid"
                />
              </div>
            </b-col>
            <b-col class="right-content" cols="8">
              <b-row class="buttons__container">
                <b-col class="mb-5 d-flex justify-content-end">
                  <a
                    v-on:click="goBack()"
                    v-if="this.active_tab > 0"
                    :class="['back-button', { disabled: !previousButtonAvailable }]"
                    >
                    <font-awesome-icon icon="angle-left" />
                    BACK
                  </a>
                  <router-link
                    :to="{ name: route }"
                    :class="['TMGeneralButton', 'blue', 'presentation-button', { disabled: !nextButtonAvailable }]"
                    @click="goNext()"
                  >
                  {{ nextButtontext }} <font-awesome-icon icon="angle-right" />
                  </router-link>
                </b-col>
              </b-row>
              <b-row>
                <div id="email-link">
                  <h3>Send by Your Personal Email</h3>
                  <p>
                    The invitation message will show up in your email
                  </p>
                  <a
                    id="email_button"
                    class="TMGeneralButton router-link-exact-active router-link-active blue"
                    v-bind:href="getMailtoText()"
                    v-on:click="enableGoToDashboardButton()"
                  >
                    SEND EMAIL
                  </a>
                </div>
              </b-row>
              <b-row>
                <div id="send-link">
                  <h3>Send by a Link</h3>
                  <p>You need to create your own invitation message</p>
                  <TMGeneralButton
                    text="COPY LINK"
                    id="link_button"
                    className="blue"
                    @click.native="copyToClipboard()"
                  />
                </div>
              </b-row>
              <b-row>
                <div id="notify-me">
                  <label for="notify" id="notify-label">
                    <input type="checkbox" v-model="emailMe" @change="updateEmailNotification($event)" name="notify" id="notify">
                    Please email me whenever someone completes a survey
                  </label>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </tab-content>
      </form-wizard>
    </b-container>
  </div>
</template>
<script>
import TMGeneralButton from "../../components/common/TMGeneralButton.vue";
import SurveyFormatTabs from "./SurveyFormatTabs";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import axios from "axios";
import Api from "@/services/api";
import {
  getAuthorizationToken
} from "@/services/utils";
export default {
  components: { TMGeneralButton, SurveyFormatTabs },
  name: "NewUserPresentation",

  mixins: [validationMixin],
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDateFormat = new Date(today);
    return {
      presentationName: "",
      selectedSurveyId: null,
      groups: {},
      keyType: "Presentation",
      form: {
        presentation_name: "",
        presentation_date: minDateFormat,
      },
      emailMe: true,
      visibleSurveyQuestions: null,
      groupSurvey: {},
      active_tab: null,
      value: 33.333333333,
      minDate: minDateFormat,
      max: 100,
      checkGroup: null,
      checkSurvey: null,
      checkSurveyFormat: null,
      overall: false,
      nextButtontext: "describe presentation",
      defaultMessages: {},
      currentWelcomeMessage: "",
      surveys: {},
      defaultWelcomeMessage: "",
      defaultThanksMessage: "",
      immutableWelcomeMessage: "Hello this is 'Presenter name', I just gave a presentation called 'Presentation name' and would greatly appreciate HONEST AND SPECIFIC feedback about my strengths and areas to improve. (Don’t worry – I can take it!) The survey is anonymous unless, at the end, you write in your name. Just click the link. It will take only about two – five minutes.\n\nTorchMetrics — the presentation feedback and coaching system you need\n\nGO TO SURVEY",
      immutableThanksMessage: "Guided by your feedback, I’ll be using TorchMetrics, an online presentation coach, to complete action steps to get better.\nThis survey comes from TorchMetrics, a unique online presentation survey and coaching tool.\nTorchMetrics — the presentation feedback and coaching system you need",
      nextButtonAvailable: false,
      previousButtonAvailable: true,
      oneSurvey: false,
      surveyCreated: null,
      route: "",
    };
  },
  watch: {
    currentWelcomeMessage: function (newValue) {
      if (this.active_tab === 1 && newValue === ""){
        this.nextButtonAvailable = false;
      }
      if(newValue != "" && this.defaultThanksMessage != "" && this.form.presentation_name != ""){
        this.nextButtonAvailable = true;
      }
    },
    defaultThanksMessage: function (newValue) {
      if (this.active_tab === 1 && newValue === ""){
        this.nextButtonAvailable = false;
      }
      if(newValue != "" && this.currentWelcomeMessage != "" && this.form.presentation_name != ""){
        this.nextButtonAvailable = true;
      }
    },
    nextButtonAvailable: function (newValue) {
      if (this.active_tab == 1 && this.defaultThanksMessage === "" && this.currentWelcomeMessage === ""){
        this.nextButtonAvailable = false;
      }
    },
    form: {
      handler: function (newValue) {
        let formatMessage = "";
        this.nextButtonAvailable = !(
          this.active_tab == 1 && newValue.presentation_name == ""
        );
        let defaultKeyPresent = true;
        const indexPresentationName = this.currentWelcomeMessage.search(
          '"Presentation name"'
        );
        let messageToUpdate = "";
        if (indexPresentationName >= 0) {
          messageToUpdate = this.currentWelcomeMessage;
        } else if (
          (this.currentWelcomeMessage.match(/"/g) || []).length === 2
        ) {
          messageToUpdate = this.currentWelcomeMessage;
          defaultKeyPresent = false;
        } else {
          messageToUpdate = this.defaultWelcomeMessage;
        }
        let newMessage = "";
        if (defaultKeyPresent) {
          newMessage = messageToUpdate.split("Presentation name");
          formatMessage = newValue.presentation_name;
        } else {
          newMessage = messageToUpdate.split('"');
          newMessage.splice(1, 1);
          formatMessage = `"${(formatMessage = newValue.presentation_name)}"`;
        }
        if (newMessage.length > 1) {
          this.currentWelcomeMessage = newMessage.join(formatMessage);
        }
      },
      deep: true,
    },
    selectedSurveyId() {
      this.nextButtonAvailable = this.selectedSurveyId && this.active_tab != 1;
    },
    checkSurvey(value) {
      if (!this.oneSurvey) this.selectedSurveyId = value;
      if (
        this.groups[this.checkGroup].surveys[value] &&
        this.groups[this.checkGroup].surveys[value].survey
      )
        this.overall = this.groups[this.checkGroup].surveys[
          value
        ].survey.overall;
      if (this.surveys[value])
        this.setDefaultMessages(
          this.surveys[value].welcome_message,
          this.surveys[value].thank_you_message
        );
    },
    checkGroup(value) {
      this.checkSurvey = null;
      this.checkSurveyFormat = null;
      this.selectedSurveyId = null;
      if (Object.keys(this.groups[value].surveys).length == 1) {
        this.oneSurvey = true;
        let surveyId = Object.keys(this.groups[value].surveys)[0];
        let survey = this.groups[value].surveys[surveyId];
        if (survey.survey && 'overall' in survey.survey)
          this.overall = survey.survey.overall;
        if (survey.survey && survey.survey.id)
          this.selectedSurveyId = survey.survey.id;
        if (this.surveys[surveyId]) {
          // always set default message if not set initially
          let welcome = this.surveys[surveyId].welcome_message || this.immutableWelcomeMessage
          let thankYou = this.surveys[surveyId].thank_you_message || this.immutableThanksMessage
          this.setDefaultMessages(
            welcome,
            thankYou
          );
        }
      } else {
        this.oneSurvey = false;
      }
      if (value == 1) {
        this.keyType = "Presentation";
        this.nextButtontext = "describe presentation";
      } else {
        this.keyType = "Survey";
        this.nextButtontext = "describe survey";
      }
    },
    groups() {
      this.groupSurvey = this.groups;
    },
  },
  validations: {
    form: {
      presentation_name: {
        required,
      },
    },
    currentWelcomeMessage: {
      required,
    },
    defaultThanksMessage: {
      required,
    },
  },
  computed: {
    ...mapState(["survey_groups_details", "currentUser"]),
  },
  methods: {
    ...mapActions(["GET_SURVEY_GROUPS_DETAILS"]),
    setDefaultMessages(welcome, thankyou) {
      if(welcome && thankyou) {
        let newMessage = welcome.split("'Presenter name'");
        this.defaultWelcomeMessage =
          newMessage.length > 1
            ? newMessage.join(this.currentUser.full_name)
            : welcome;
        const index = this.defaultWelcomeMessage.search("'Presentation name'");
        if (index >= 0) {
          const defaultMessage = this.defaultWelcomeMessage
            .split("'Presentation name'")
            .join('"Presentation name"'); //TODO: Ask BE to send this with double quotes
          this.defaultWelcomeMessage = defaultMessage;
        }
        this.currentWelcomeMessage = this.defaultWelcomeMessage;
        this.defaultThanksMessage = thankyou;
      }
    },
    enableGoToDashboardButton() {
      this.route = "UserDashboard";
      this.nextButtonAvailable = true;
    },
    setCheckSurveyFormat(format) {
      this.checkSurveyFormat = format;
    },
    copyToClipboard(id = null) {
      this.route = "UserDashboard";
      this.nextButtonAvailable = true;
      if (this.surveyCreated && this.surveyCreated.id) {
        id = this.surveyCreated.id;
      }
      let path = this.$router.resolve({
        name: "TakeSurvey",
        params: { id },
      }).href;
      let fullURL = window.location.origin + path;
      try {
        navigator.clipboard.writeText(fullURL);
      } catch (e) {
        throw e;
      }
    },
    getMailtoText() {
      let localData = JSON.parse(localStorage.getItem("currentUser"));
      var message = encodeURI(this.currentWelcomeMessage);
      var subjet = "Invitation from " + localData.full_name + " to give feedback";
      let fullURL = "";
      if (this.surveyCreated && this.surveyCreated.id) {
        let path = this.$router.resolve({
          name: "TakeSurvey",
          params: { id: this.surveyCreated.id },
        }).href;
        fullURL = window.location.origin + path;
      }
      return `mailto:?subject=${subjet}&body=${message}%0D%0A%0D%0A${fullURL}`;
    },
    toggleQuestions(surveyId) {
      this.visibleSurveyQuestions =
        this.visibleSurveyQuestions == surveyId ? null : surveyId;
    },
    notEmptyObject(someObject) {
      return Object.keys(someObject).length;
    },
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data.form, isValid);
      return isValid;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateExtraFields(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    goNext() {
      if (this.nextButtonAvailable) {
        if (this.active_tab === null || this.active_tab === 0) {
          this.nextButtonAvailable = false;
          this.$v.form["presentation_name"].$reset();
          this.form.presentation_name = "";
          this.nextButtontext = "share survey";
          this.value = 66.666666;
          this.previousButtonAvailable = true;
        } else if (this.active_tab === 1) {
          this.previousButtonAvailable = false;
          this.nextButtontext = "go to dashboard";
          this.nextButtonAvailable = false;
          this.value = 100;
          this.sendSurvey();
        }
        this.$refs.wizard.nextTab();
        this.active_tab = this.$refs.wizard.activeTabIndex;
      }
    },
    sendSurvey() {
      const customInstance = axios.create({
        baseURL: process.env.VUE_APP_SERVER_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getAuthorizationToken(),
        },
      });
      customInstance
        .post("user/presentations", {
          presentation: {
            name: this.form.presentation_name,
            welcome_message: this.currentWelcomeMessage,
            thank_you_message: this.defaultThanksMessage,
            survey_id: this.selectedSurveyId,
            date: this.form.presentation_date,
            notify_when_survey_complete: this.emailMe,
          },
        })
        .then((res) => {
          this.surveyCreated = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      if (this.active_tab === 1) {
        this.nextButtonAvailable = true;
        let keyType = this.keyType;
        this.nextButtontext = `DESCRIBE ${keyType.toUpperCase()}`;
        this.value = 33.333333333;
        this.$v.currentWelcomeMessage.$reset();
        this.$v.defaultThanksMessage.$reset();
        this.currentWelcomeMessage = "";
        this.defaultThanksMessage = "";
        this.$refs.wizard.prevTab();
        this.active_tab = this.$refs.wizard.activeTabIndex;
      }
    },
    getSurveyGroups(id = null) {
      let params = {};
      if (id) {
        params = {
          id,
        };
      }
      Api()
        .get(`survey_groups/${id}`, {
          params,
          headers: {
            Authorization: getAuthorizationToken(),
          },
        })
        .then((res) => {
          let surveys = res.data.length > 0 ? res.data[0].surveys : [];
          if (surveys.length) {
            this.groups[id].show = true;
            if (surveys.length > 1) this.groups[id].multiple = true;
            surveys.forEach((survey) => {
              this.groups[id].surveys[survey.id] = {
                title: survey.title,
                survey: {},
              };
              this.defaultMessages[survey.id] = {
                welcomeMessage: "",
                thankyouMessage: "",
              };
              this.getSurveys(id, survey.id);
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSurveys(groupId, surveyId) {
      let params = {};
      Api()
        .get(`surveys/${surveyId}`, {
          params,
          headers: {
            Authorization: getAuthorizationToken(),
          },
        })
        .then((res) => {
          this.groups[groupId].surveys[surveyId].survey = res.data;
          this.surveys[surveyId] = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateEmailNotification(event) {
      let body = {
          presentation: {
            notify_when_survey_complete: this.emailMe,
        }
      };
      Api()
        .patch(`user/presentations/${this.surveyCreated.id}`, body, {
          headers: {
            Authorization: getAuthorizationToken(),
          },
        })
        .then((res) => {
          console.log('OK');
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.GET_SURVEY_GROUPS_DETAILS();
    Api()
      .get("survey_groups", {
        // params: {
        //   presentations_ids: this.id,
        // },
        headers: {
          Authorization: getAuthorizationToken(),
        },
      })
      .then((res) => {
        res.data.forEach((group) => {
          this.$set(this.groups, group.id, {});

          this.groups[group.id] = {
            name: group.name,
            surveys: {},
            description: group.description,
            show: false,
            multiple: false,
          };
          this.getSurveyGroups(group.id);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style lang="less">
@import "../../assets/components/sendSurvey/sendSurvey.less";
@import "../../assets/general/TorchMetrics.less";
</style>